//
//
//
//
//
//
export default {
  name: 'SanityWidget',
  props: {
    externalJs: {
      type: String
    },
    uploadedFile: {
      type: String
    },
    divId: {
      type: String
    },
    bgColor: {
      type: String
    }
  },
  computed: {
    style() {
      return {
        'background-color': this.bgColor ? this.bgColor : ''
      };
    }

  }
};